import { createFileRoute } from "@tanstack/react-router";
import { FileTextIcon } from "lucide-react";
import { LetterheadManager } from "@/components/admin/letterhead-manager";
import { requireAdminSection } from "@/lib/admin-guard";

export const Route = createFileRoute("/_admin/templates")({
  beforeLoad: ({ context }) => requireAdminSection(context.auth.capabilities, "templates"),
  component: AdminTemplatesPage,
});

function AdminTemplatesPage() {
  return (
    <div className="flex flex-1 flex-col gap-8 p-6">
      <header className="flex flex-col gap-2">
        <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
          <FileTextIcon className="size-3.5" />
          Governance
        </div>
        <div className="flex flex-col gap-1">
          <h1 className="font-heading text-3xl font-semibold tracking-tight">Letterheads</h1>
          <p className="max-w-2xl text-sm text-muted-foreground">
            Shared letterhead templates for every workspace's generated documents. You design the
            layout and style; each workspace's own company name, logo, and contact details fill in
            at render time.
          </p>
        </div>
      </header>

      <LetterheadManager />
    </div>
  );
}
